import { toast } from "react-toastify";

import NewScheduling from "../../../api/new-scheduling";

export const newScheduling = {
  state: {
    loading: false,
    confirmed: false,
    loseConfigsWhenExit: true,
    scheduling: null,
  },
  reducers: {
    setConfirmed(state, payload) {
      return { ...state, confirmed: payload };
    },
    setScheduling(state, payload) {
      return { ...state, ...payload };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    loseConfigsWhenExit(state, payload) {
      return { ...state, loseConfigsWhenExit: payload };
    },
    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async addAsync(payload, _rootState) {
      try {
        this.loading({ loading: true });
        const { data } = await NewScheduling.add(payload);
        this.setScheduling({
          loading: false,
          confirmed: true,
          scheduling: data,
        });
      } catch (error) {
        this.setScheduling({
          loading: false,
          confirmed: false,
          scheduling: null,
        });
        if (error.response.data && error.response.data.includes('Not available quota!')) {
          return {
            success: false,
            message: "no-quota",
          };  
        }
        toast.error(error.response.data || "Erro ao confirmar agendamento!");
        return {
          success: false,
          message: error.response.data || "Erro ao confirmar agendamento!",
        };

      }
      return { success: true, message: "Agendamento adicionado com sucesso." };
    },
    async loseConfigsWhenExitAsync(payload, rootState) {
      this.loseConfigsWhenExit(payload);
    },
  }),
};
